import React, { useState, useEffect, useRef } from "react";
import {
  collection, query, where, onSnapshot, doc, getDoc,
  getDocs, addDoc, serverTimestamp, orderBy
} from "firebase/firestore";
import { db, auth } from "./firebase";

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400;1,600&family=Jost:wght@200;300;400;500&display=swap');
@import url('https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/tabler-icons.min.css');

*,*::before,*::after{margin:0;padding:0;box-sizing:border-box;}

:root{
  --rose:#C4899A;
  --rose-light:#EDD9DF;
  --rose-dark:#8B5A6A;
  --plum:#83005e;
  --cream:#FAF6F1;
  --ivory:#F5EEE6;
  --warm-white:#FFFCF9;
  --muted:#9A8A85;
  --gold:#C9A96E;
  --gold-light:#F5E6CE;
  --text-dark:#2D1B25;
  --text-mid:#6B5058;
  --border:rgba(196,137,154,0.18);
  --nav-w:260px;
  --radius:22px;
}

html,body{height:100%;background:var(--cream);}

::-webkit-scrollbar{width:4px;}
::-webkit-scrollbar-track{background:transparent;}
::-webkit-scrollbar-thumb{background:var(--rose-light);border-radius:4px;}

.md-root{
  display:flex;
  min-height:100vh;
  font-family:'Jost',sans-serif;
  color:var(--text-dark);
  position:relative;
}

/* Sidebar - version mobile avec slide */
.md-sidebar{
  width:var(--nav-w);
  background:var(--plum);
  position:fixed;
  top:0;left:0;bottom:0;
  z-index:100;
  display:flex;
  flex-direction:column;
  overflow:hidden;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.md-sidebar::before{
  content:'';position:absolute;
  width:300px;height:300px;border-radius:50%;
  background:rgba(196,137,154,0.1);
  top:-100px;right:-100px;pointer-events:none;
}
.md-sidebar::after{
  content:'';position:absolute;
  width:180px;height:180px;border-radius:50%;
  background:rgba(196,137,154,0.07);
  bottom:60px;left:-60px;pointer-events:none;
}

.md-brand{
  padding:32px 28px 20px;
  position:relative;z-index:2;
}
.md-brand-badge{
  display:inline-flex;align-items:center;gap:6px;
  background:rgba(237,217,223,0.12);
  border:1px solid rgba(237,217,223,0.2);
  border-radius:40px;
  padding:4px 12px;
  font-size:10px;
  letter-spacing:0.18em;
  text-transform:uppercase;
  color:rgba(237,217,223,0.6);
  margin-bottom:16px;
}
.md-brand-badge i{font-size:12px;color:var(--rose-light);}
.md-brand-name{
  font-family:'Cormorant Garamond',serif;
  font-size:24px;font-weight:600;
  color:white;line-height:1.1;
}
.md-brand-name em{font-style:italic;color:var(--rose-light);}
.md-brand-sub{font-size:11px;letter-spacing:0.18em;text-transform:uppercase;color:rgba(237,217,223,0.45);margin-top:5px;}

.md-sidebar-sep{height:1px;background:rgba(255,255,255,0.07);margin:12px 28px 16px;}

.md-nav{
  flex:1;padding:0 16px;display:flex;flex-direction:column;gap:3px;position:relative;z-index:2;
}
.md-nav-section{
  font-size:10px;letter-spacing:0.2em;text-transform:uppercase;
  color:rgba(255,255,255,0.25);padding:12px 16px 6px;font-weight:500;
}
.md-nav-item{
  display:flex;align-items:center;gap:12px;
  padding:11px 16px;border-radius:12px;
  cursor:pointer;transition:all 0.2s;
  border:none;background:transparent;width:100%;text-align:left;
  color:rgba(255,255,255,0.5);
  font-family:'Jost',sans-serif;font-size:13.5px;font-weight:400;
  position:relative;
}
.md-nav-item:hover{background:rgba(255,255,255,0.07);color:rgba(255,255,255,0.85);}
.md-nav-item.active{background:rgba(196,137,154,0.2);color:var(--rose-light);font-weight:500;}
.md-nav-item.active::before{
  content:'';position:absolute;left:0;top:50%;transform:translateY(-50%);
  width:3px;height:18px;background:var(--rose);border-radius:0 3px 3px 0;
}
.md-nav-item i{font-size:18px;flex-shrink:0;width:20px;text-align:center;}
.md-nav-badge{
  margin-left:auto;background:var(--rose);color:white;
  font-size:10px;font-weight:600;
  min-width:18px;height:18px;border-radius:9px;
  display:flex;align-items:center;justify-content:center;padding:0 5px;
}

.md-sidebar-footer{padding:20px 16px 28px;position:relative;z-index:2;}
.md-midwife-card{
  background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.1);
  border-radius:14px;padding:14px 16px;
  display:flex;align-items:center;gap:12px;margin-bottom:12px;
}
.md-midwife-avatar{
  width:38px;height:38px;border-radius:50%;
  background:linear-gradient(135deg,var(--rose),var(--rose-dark));
  display:flex;align-items:center;justify-content:center;
  font-size:16px;color:white;flex-shrink:0;
}
.md-midwife-name{font-size:13px;color:white;font-weight:500;}
.md-midwife-role{font-size:11px;color:rgba(237,217,223,0.5);margin-top:2px;}
.md-logout{
  display:flex;align-items:center;gap:10px;padding:10px 14px;
  border-radius:12px;border:1px solid rgba(255,255,255,0.08);background:transparent;
  width:100%;color:rgba(255,255,255,0.4);font-family:'Jost',sans-serif;font-size:13px;
  cursor:pointer;transition:all 0.2s;
}
.md-logout:hover{background:rgba(255,80,80,0.1);border-color:rgba(255,80,80,0.2);color:#ff9090;}
.md-logout i{font-size:16px;}

.md-main{
  margin-left:var(--nav-w);flex:1;display:flex;flex-direction:column;min-height:100vh;
  background:var(--cream);
  transition: margin-left 0.3s ease;
}

.md-topbar{
  background:var(--warm-white);border-bottom:1px solid var(--border);
  padding:0 36px;height:64px;
  display:flex;align-items:center;justify-content:space-between;
  position:sticky;top:0;z-index:50;
}
.md-topbar-title{font-family:'Cormorant Garamond',serif;font-size:21px;font-weight:400;color:var(--plum);font-style:italic;}
.md-topbar-right{display:flex;align-items:center;gap:14px;}
.md-topbar-date{font-size:12px;color:var(--muted);display:flex;align-items:center;gap:6px;}
.md-topbar-date i{font-size:14px;color:var(--rose);}

.md-content{padding:32px 36px 60px;flex:1;}

@keyframes fadeUp{from{opacity:0;transform:translateY(12px);}to{opacity:1;transform:translateY(0);}}
.md-animate{animation:fadeUp 0.32s ease both;}
.md-animate>*{animation:fadeUp 0.32s ease both;}
.md-animate>*:nth-child(1){animation-delay:.04s;}
.md-animate>*:nth-child(2){animation-delay:.08s;}
.md-animate>*:nth-child(3){animation-delay:.12s;}
.md-animate>*:nth-child(4){animation-delay:.16s;}
.md-animate>*:nth-child(5){animation-delay:.20s;}

.md-stats-row{display:grid;grid-template-columns:repeat(4,1fr);gap:14px;margin-bottom:28px;}
.md-stat-card{
  background:white;border-radius:18px;border:1px solid var(--border);
  padding:20px 22px;display:flex;align-items:center;gap:14px;
  transition:transform 0.2s,box-shadow 0.2s;cursor:default;
}
.md-stat-card:hover{transform:translateY(-2px);box-shadow:0 8px 28px rgba(139,90,106,0.08);}
.md-stat-ico{
  width:44px;height:44px;border-radius:12px;
  display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0;
}
.md-stat-ico.rose{background:var(--rose-light);color:var(--rose-dark);}
.md-stat-ico.gold{background:var(--gold-light);color:#9A7A40;}
.md-stat-ico.plum{background:#f0e0f0;color:var(--plum);}
.md-stat-ico.sage{background:#dff0e8;color:#3a7a5a;}
.md-stat-n{font-family:'Cormorant Garamond',serif;font-size:28px;font-weight:600;color:var(--text-dark);line-height:1;}
.md-stat-l{font-size:11px;color:var(--muted);letter-spacing:.06em;text-transform:uppercase;margin-top:3px;}

.md-sh{font-family:'Cormorant Garamond',serif;font-size:30px;font-weight:400;color:var(--plum);letter-spacing:-.01em;margin-bottom:6px;}
.md-sh em{font-style:italic;color:var(--rose-dark);}
.md-ssub{font-size:13px;color:var(--muted);font-weight:300;margin-bottom:24px;}

.md-patients-layout{display:grid;grid-template-columns:340px 1fr;gap:20px;height:calc(100vh - 210px);}

.md-plist-wrap{
  background:white;border-radius:var(--radius);border:1px solid var(--border);
  display:flex;flex-direction:column;overflow:hidden;
}
.md-plist-header{
  padding:20px 22px 16px;border-bottom:1px solid var(--border);
}
.md-plist-search{
  display:flex;align-items:center;gap:10px;
  background:var(--cream);border:1.5px solid var(--border);border-radius:40px;
  padding:9px 16px;transition:border-color .2s;
}
.md-plist-search:focus-within{border-color:var(--rose);}
.md-plist-search i{font-size:15px;color:var(--muted);}
.md-plist-search input{
  border:none;background:transparent;outline:none;
  font-family:'Jost',sans-serif;font-size:13.5px;color:var(--text-dark);width:100%;
}
.md-plist-search input::placeholder{color:var(--muted);}
.md-plist-count{font-size:11px;color:var(--muted);letter-spacing:.06em;text-transform:uppercase;margin-top:12px;}

.md-plist{flex:1;overflow-y:auto;padding:8px 10px;}
.md-pitem{
  display:flex;align-items:center;gap:14px;
  padding:14px 14px;border-radius:14px;cursor:pointer;
  transition:background .18s;border:1.5px solid transparent;margin-bottom:4px;
}
.md-pitem:hover{background:var(--ivory);}
.md-pitem.selected{background:var(--rose-light);border-color:rgba(196,137,154,0.35);}
.md-pitem-av{
  width:42px;height:42px;border-radius:50%;flex-shrink:0;
  display:flex;align-items:center;justify-content:center;
  font-family:'Cormorant Garamond',serif;font-size:18px;font-weight:600;color:white;
}
.md-pitem-name{font-size:14px;font-weight:500;color:var(--text-dark);line-height:1.2;}
.md-pitem-info{font-size:12px;color:var(--muted);margin-top:2px;}
.md-pitem-badge{
  margin-left:auto;font-size:11px;padding:3px 9px;border-radius:40px;
  font-weight:500;flex-shrink:0;
}
.md-pitem-badge.active{background:#e8f7ee;color:#2e7d52;}
.md-pitem-badge.pending{background:var(--gold-light);color:#7a5a20;}

.md-pdetail{
  background:white;border-radius:var(--radius);border:1px solid var(--border);
  display:flex;flex-direction:column;overflow:hidden;
}
.md-pdetail-empty{
  flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;
  gap:16px;color:var(--muted);
}
.md-pdetail-empty i{font-size:52px;opacity:.25;}
.md-pdetail-empty p{font-size:14px;font-weight:300;}

.md-pdetail-header{
  padding:28px 32px 22px;border-bottom:1px solid var(--border);
  background:linear-gradient(135deg,var(--plum),#5a003f);
  position:relative;overflow:hidden;
}
.md-pdetail-header::before{
  content:'';position:absolute;width:240px;height:240px;border-radius:50%;
  background:rgba(196,137,154,0.1);top:-80px;right:-60px;pointer-events:none;
}
.md-pdetail-hrow{display:flex;align-items:center;gap:18px;position:relative;z-index:2;}
.md-pdetail-av{
  width:62px;height:62px;border-radius:50%;flex-shrink:0;
  display:flex;align-items:center;justify-content:center;
  font-family:'Cormorant Garamond',serif;font-size:26px;font-weight:600;color:white;
  border:2.5px solid rgba(237,217,223,0.35);
}
.md-pdetail-name{font-family:'Cormorant Garamond',serif;font-size:26px;font-weight:400;color:white;line-height:1.1;}
.md-pdetail-name em{font-style:italic;color:var(--rose-light);}
.md-pdetail-email{font-size:12.5px;color:rgba(255,255,255,0.5);margin-top:4px;letter-spacing:.02em;}
.md-pdetail-chips{display:flex;gap:8px;margin-top:12px;flex-wrap:wrap;position:relative;z-index:2;}
.md-chip{
  display:inline-flex;align-items:center;gap:5px;
  padding:4px 12px;border-radius:40px;font-size:11px;font-weight:500;letter-spacing:.04em;
  background:rgba(237,217,223,0.15);border:1px solid rgba(237,217,223,0.25);color:rgba(237,217,223,0.8);
}
.md-chip i{font-size:12px;}

.md-detail-tabs{
  display:flex;border-bottom:1px solid var(--border);background:var(--warm-white);
}
.md-dtab{
  padding:14px 22px;font-size:13px;font-weight:400;color:var(--muted);
  cursor:pointer;border:none;background:transparent;font-family:'Jost',sans-serif;
  border-bottom:2.5px solid transparent;transition:all .2s;display:flex;align-items:center;gap:7px;
}
.md-dtab i{font-size:15px;}
.md-dtab:hover{color:var(--text-dark);}
.md-dtab.active{color:var(--plum);border-bottom-color:var(--rose);font-weight:500;}

.md-detail-body{flex:1;overflow-y:auto;padding:24px 32px;}

.md-info-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;}
.md-info-field{background:var(--cream);border-radius:12px;padding:14px 18px;}
.md-info-field-label{font-size:10.5px;letter-spacing:.14em;text-transform:uppercase;color:var(--rose);font-weight:500;margin-bottom:5px;}
.md-info-field-val{font-size:14px;color:var(--text-dark);font-weight:400;line-height:1.5;}
.md-info-field.full{grid-column:1/-1;}

.md-detail-alert{
  display:flex;align-items:flex-start;gap:14px;
  background:#FFF8EE;border:1.5px solid rgba(201,169,110,.3);border-radius:14px;padding:16px 18px;
  margin-bottom:20px;
}
.md-detail-alert i{color:var(--gold);font-size:20px;flex-shrink:0;margin-top:1px;}
.md-detail-alert-text{font-size:13.5px;color:#6B5030;line-height:1.6;font-weight:300;}

.md-chat-wrap{display:flex;flex-direction:column;height:100%;}
.md-messages{flex:1;overflow-y:auto;display:flex;flex-direction:column;gap:12px;padding-bottom:8px;width:100%;}
.md-msg{display:flex;flex-direction:column;max-width:70%;width:fit-content;}
.md-msg.mine{align-self:flex-end;align-items:flex-end;margin-left:auto;}
.md-msg.theirs{align-self:flex-start;align-items:flex-start;margin-right:auto;}
.md-msg-bubble{
  padding:11px 16px;border-radius:16px;font-size:13.5px;line-height:1.6;font-weight:300;
}
.md-msg.mine .md-msg-bubble{background:var(--plum);color:white;border-bottom-right-radius:4px;}
.md-msg.theirs .md-msg-bubble{background:var(--cream);color:var(--text-dark);border:1px solid var(--border);border-bottom-left-radius:4px;}
.md-msg-time{font-size:10.5px;color:var(--muted);margin-top:3px;padding:0 4px;}
.md-chat-empty{
  flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;
  gap:12px;color:var(--muted);
}
.md-chat-empty i{font-size:40px;opacity:.2;}
.md-chat-empty p{font-size:13px;font-weight:300;}
.md-chat-input-bar{
  border-top:1px solid var(--border);padding:14px 0 0;
  display:flex;gap:10px;align-items:center;margin-top:16px;
}
.md-chat-inp{
  flex:1;padding:11px 18px;border:1.5px solid var(--border);border-radius:40px;
  background:var(--cream);font-family:'Jost',sans-serif;font-size:13.5px;outline:none;
  color:var(--text-dark);transition:border-color .2s;
}
.md-chat-inp:focus{border-color:var(--rose);background:white;}
.md-chat-inp::placeholder{color:var(--muted);}
.md-send-btn{
  width:42px;height:42px;border-radius:50%;background:var(--plum);border:none;
  cursor:pointer;display:flex;align-items:center;justify-content:center;
  flex-shrink:0;transition:background .2s,transform .15s;
}
.md-send-btn:hover{background:var(--rose-dark);transform:scale(1.06);}
.md-send-btn i{color:white;font-size:17px;}

.md-inbox-layout{display:grid;grid-template-columns:320px 1fr;gap:0;height:calc(100vh - 210px);background:white;border-radius:var(--radius);border:1px solid var(--border);overflow:hidden;}
.md-inbox-list{border-right:1px solid var(--border);display:flex;flex-direction:column;overflow:hidden;}
.md-inbox-list-header{padding:20px 20px 14px;border-bottom:1px solid var(--border);background:var(--warm-white);}
.md-inbox-list-title{font-family:'Cormorant Garamond',serif;font-size:20px;font-weight:400;color:var(--plum);}
.md-inbox-list-sub{font-size:11.5px;color:var(--muted);margin-top:3px;}
.md-inbox-list-body{flex:1;overflow-y:auto;padding:8px;}
.md-inbox-row{
  display:flex;align-items:center;gap:12px;padding:14px 14px;border-radius:14px;
  cursor:pointer;transition:background .18s;border:1.5px solid transparent;margin-bottom:3px;
}
.md-inbox-row:hover{background:var(--ivory);}
.md-inbox-row.active{background:var(--rose-light);border-color:rgba(196,137,154,.3);}
.md-inbox-av{
  width:44px;height:44px;border-radius:50%;display:flex;align-items:center;justify-content:center;
  font-family:'Cormorant Garamond',serif;font-size:18px;font-weight:600;color:white;flex-shrink:0;
}
.md-inbox-info{flex:1;min-width:0;}
.md-inbox-name{font-size:14px;font-weight:500;color:var(--text-dark);line-height:1.2;}
.md-inbox-preview{font-size:12px;color:var(--muted);margin-top:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.md-inbox-meta{display:flex;flex-direction:column;align-items:flex-end;gap:5px;flex-shrink:0;}
.md-inbox-time{font-size:11px;color:var(--muted);}
.md-inbox-unread{
  background:var(--rose);color:white;font-size:10px;font-weight:600;
  min-width:18px;height:18px;border-radius:9px;display:flex;align-items:center;justify-content:center;padding:0 5px;
}
.md-inbox-panel{display:flex;flex-direction:column;overflow:hidden;}
.md-inbox-panel-header{
  padding:20px 28px;border-bottom:1px solid var(--border);background:var(--warm-white);
  display:flex;align-items:center;gap:14px;
}
.md-inbox-panel-av{
  width:44px;height:44px;border-radius:50%;display:flex;align-items:center;justify-content:center;
  font-family:'Cormorant Garamond',serif;font-size:18px;font-weight:600;color:white;flex-shrink:0;
}
.md-inbox-panel-name{font-size:15px;font-weight:500;color:var(--text-dark);}
.md-inbox-panel-status{font-size:12px;color:var(--muted);display:flex;align-items:center;gap:6px;margin-top:2px;}
.md-online-dot{width:7px;height:7px;border-radius:50%;background:#5cb85c;}
.md-inbox-messages{flex:1;overflow-y:auto;padding:24px 28px;display:flex;flex-direction:column;gap:12px;background:var(--cream);}
.md-inbox-empty{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;color:var(--muted);}
.md-inbox-empty i{font-size:52px;opacity:.2;}
.md-inbox-empty p{font-size:14px;font-weight:300;}

.md-toast{
  position:fixed;bottom:28px;right:28px;
  background:var(--plum);color:white;
  padding:13px 22px;border-radius:14px;font-size:13.5px;
  display:flex;align-items:center;gap:10px;z-index:999;
  box-shadow:0 8px 32px rgba(131,0,94,0.28);animation:slideIn .3s ease;
}
.md-toast i{font-size:17px;color:var(--rose-light);}
@keyframes slideIn{from{opacity:0;transform:translateX(20px);}to{opacity:1;transform:translateX(0);}}

.md-quick-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:16px;margin-top:24px;}
.md-quick-card{
  background:white;border-radius:18px;border:1px solid var(--border);padding:24px 26px;
  display:flex;flex-direction:column;gap:12px;
  transition:transform .2s,box-shadow .2s;cursor:default;
}
.md-quick-card:hover{transform:translateY(-2px);box-shadow:0 8px 28px rgba(139,90,106,0.08);}
.md-quick-card-title{font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:var(--rose);font-weight:500;}
.md-quick-card-list{display:flex;flex-direction:column;gap:10px;}
.md-quick-row{display:flex;align-items:center;justify-content:space-between;font-size:13.5px;}
.md-quick-row-name{color:var(--text-dark);font-weight:400;}
.md-quick-row-val{color:var(--muted);font-size:12.5px;}
.md-quick-row-dot{width:8px;height:8px;border-radius:50%;flex-shrink:0;margin-right:10px;}

/* Hamburger button for mobile */
.md-mobile-menu-btn {
  display: none;
  position: fixed;
  top: 14px;
  left: 16px;
  z-index: 200;
  width: 38px; height: 38px;
  border-radius: 10px;
  background: var(--plum);
  border: none;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 12px rgba(131,0,94,0.3);
  transition: background 0.2s;
}
.md-mobile-menu-btn i { color: white; font-size: 20px; }

.md-sidebar-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 99;
  backdrop-filter: blur(2px);
}

/* Responsive breakpoints */
@media (max-width: 1024px) {
  :root { --nav-w: 220px; }
  .md-content { padding: 24px 24px 48px; }
  .md-topbar { padding: 0 24px; }
  .md-stats-row { grid-template-columns: repeat(2, 1fr); gap: 12px; }
  .md-patients-layout { grid-template-columns: 280px 1fr; gap: 16px; height: auto; min-height: 500px; }
  .md-inbox-layout { grid-template-columns: 280px 1fr; height: auto; min-height: 500px; }
  .md-quick-grid { grid-template-columns: 1fr; gap: 14px; }
  .md-sh { font-size: 28px; }
}

@media (max-width: 768px) {
  :root { --nav-w: 260px; }
  
  .md-mobile-menu-btn { display: flex; }
  
  .md-sidebar {
    transform: translateX(-100%);
    width: min(280px, 85vw);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .md-sidebar.mobile-open {
    transform: translateX(0);
  }
  
  .md-sidebar-overlay.mobile-open {
    display: block;
  }
  
  .md-main {
    margin-left: 0;
  }
  
  .md-topbar {
    padding: 0 16px 0 64px;
    height: 56px;
  }
  .md-topbar-title { font-size: 17px; }
  .md-topbar-date { display: none; }
  
  .md-content {
    padding: 20px 16px 100px;
  }
  
  .md-stats-row {
    grid-template-columns: 1fr;
    gap: 10px;
    margin-bottom: 20px;
  }
  .md-stat-card { padding: 16px 18px; }
  
  .md-patients-layout {
    grid-template-columns: 1fr;
    gap: 20px;
    height: auto;
  }
  .md-plist-wrap { max-height: 400px; }
  .md-pdetail { min-height: 500px; }
  
  .md-inbox-layout {
    grid-template-columns: 1fr;
    height: auto;
  }
  .md-inbox-list {
    border-right: none;
    border-bottom: 1px solid var(--border);
    max-height: 350px;
  }
  .md-inbox-panel { min-height: 450px; }
  .md-inbox-messages { padding: 20px 16px; }
  .md-inbox-panel-header { padding: 16px 20px; }
  
  .md-detail-body { padding: 20px 20px; }
  .md-info-grid { grid-template-columns: 1fr; gap: 10px; }
  .md-pdetail-header { padding: 20px 20px 16px; }
  .md-pdetail-hrow { gap: 12px; }
  .md-pdetail-av { width: 48px; height: 48px; font-size: 20px; }
  .md-pdetail-name { font-size: 22px; }
  .md-dtab { padding: 12px 16px; font-size: 12px; }
  .md-quick-card { padding: 18px 20px; }
  .md-sh { font-size: 24px; }
  .md-ssub { font-size: 12px; margin-bottom: 20px; }
  .md-brand { padding: 24px 20px 16px; }
  .md-brand-name { font-size: 20px; }
  .md-nav-item { padding: 8px 12px; font-size: 12px; }
  .md-nav-item i { font-size: 16px; }
  .md-midwife-card { padding: 10px 12px; }
  .md-midwife-name { font-size: 12px; }
  .md-logout { padding: 8px 12px; font-size: 12px; }
  .md-chat-inp { font-size: 12px; padding: 9px 14px; }
  .md-send-btn { width: 36px; height: 36px; }
  .md-send-btn i { font-size: 15px; }
  .md-msg-bubble { font-size: 12px; padding: 8px 12px; }
  .md-msg { max-width: 85%; }
  .md-content > div[style*="linear-gradient"] {
    padding: 28px 24px !important;
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
  .md-content > div[style*="linear-gradient"] h1 { font-size: 28px !important; }
}

@media (max-width: 480px) {
  :root { --nav-w: 260px; }
  
  .md-brand { padding: 20px 14px 12px; }
  .md-brand-badge { font-size: 9px; padding: 3px 8px; }
  .md-brand-name { font-size: 18px; }
  .md-brand-sub { font-size: 9px; }
  .md-nav { padding: 0 8px; }
  .md-nav-item { padding: 7px 10px; gap: 8px; }
  .md-nav-item i { font-size: 14px; width: 18px; }
  .md-nav-badge { font-size: 9px; min-width: 16px; height: 16px; }
  .md-midwife-card { padding: 8px 10px; gap: 8px; }
  .md-midwife-avatar { width: 30px; height: 30px; font-size: 14px; }
  .md-midwife-name { font-size: 11px; }
  .md-midwife-role { font-size: 9px; }
  .md-logout { font-size: 11px; padding: 7px 10px; }
  .md-topbar { height: 56px; }
  .md-topbar-title { font-size: 16px; }
  .md-topbar-right { gap: 8px; }
  .md-topbar-date { display: none; }
  .md-content { padding: 16px 16px 32px; }
  .md-stat-card { padding: 12px 14px; }
  .md-stat-ico { width: 36px; height: 36px; font-size: 16px; }
  .md-stat-n { font-size: 24px; }
  .md-sh { font-size: 22px; }
  .md-plist-header { padding: 14px 16px; }
  .md-pitem { padding: 10px 12px; }
  .md-pitem-av { width: 34px; height: 34px; font-size: 14px; }
  .md-pitem-name { font-size: 13px; }
  .md-pitem-info { font-size: 10px; }
  .md-pdetail-header { padding: 16px 16px 12px; }
  .md-pdetail-av { width: 40px; height: 40px; font-size: 18px; }
  .md-pdetail-name { font-size: 20px; }
  .md-pdetail-email { font-size: 10px; }
  .md-chip { font-size: 9px; padding: 2px 8px; }
  .md-dtab { padding: 10px 12px; font-size: 11px; }
  .md-detail-body { padding: 16px; }
  .md-info-field { padding: 10px 12px; }
  .md-info-field-val { font-size: 13px; }
  .md-quick-card { padding: 16px; }
  .md-quick-card-title { font-size: 11px; }
  .md-quick-row { font-size: 12px; }
}
`;

// دوال مساعدة
const PALETTE = ["#C4899A","#8B5A6A","#83005e","#C9A96E","#8BA89A"];
const getColor = (name) => PALETTE[name?.charCodeAt(0) % PALETTE.length] || "#C4899A";
const getInitials = (name) => name?.split(" ").map(w => w[0]).join("").toUpperCase().slice(0,2) || "?";
const formatDate = (d) => d ? new Date(d).toLocaleDateString("fr-FR",{day:"numeric",month:"long",year:"numeric"}) : "—";

export default function MidwifeDashboard({ onLogout = () => {} }) {
  const [tab, setTab] = useState("overview");
  const [patients, setPatients] = useState([]);
  const [chats, setChats] = useState({});
  const [selected, setSelected] = useState(null);
  const [detailTab, setDetailTab] = useState("info");
  const [search, setSearch] = useState("");
  const [newMsg, setNewMsg] = useState("");
  const [toast, setToast] = useState(null);
  const messagesEnd = useRef(null);
  const [inboxSelected, setInboxSelected] = useState(null);
  const [inboxMsg, setInboxMsg] = useState("");
  const [midwifeId, setMidwifeId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [appointments, setAppointments] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const closeSidebar = () => setSidebarOpen(false);
  const handleNavClick = (id) => {
    setTab(id);
    setSidebarOpen(false);
  };

  // التحقق من البريد الإلكتروني للقابلة
  useEffect(() => {
    const user = auth.currentUser;
    if (user && user.email?.toLowerCase() !== "rosyhealth@gmail.com") {
      onLogout();
      return;
    }
    if (user) setMidwifeId(user.uid);
  }, [onLogout]);

  // جلب قائمة المرضى
  useEffect(() => {
    if (!midwifeId) return;
    setLoading(true);
    const patientsRef = collection(db, "users");
    const q = query(patientsRef, where("role", "==", "patient"));
    const unsubscribe = onSnapshot(q, async (snapshot) => {
      if (snapshot.empty) {
        console.warn("⚠️ Aucun patient trouvé (role=patient)");
        setPatients([]);
        setLoading(false);
        return;
      }
      const patientList = [];
      for (const docSnap of snapshot.docs) {
        const uid = docSnap.id;
        const userData = docSnap.data();
        const medRef = doc(db, "patients_medical_info", uid);
        const medSnap = await getDoc(medRef);
        const medData = medSnap.exists() ? medSnap.data() : {};
        const sterRef = doc(db, "patients_sterilet", uid);
        const sterSnap = await getDoc(sterRef);
        const sterData = sterSnap.exists() ? sterSnap.data() : {};
        let lastAppt = null;
        try {
          const apptQuery = query(collection(db, "appointments"), where("patientId", "==", uid));
          const apptSnapshot = await getDocs(apptQuery);
          if (!apptSnapshot.empty) lastAppt = apptSnapshot.docs[0].data();
        } catch (err) { console.warn(err); }
        patientList.push({
          uid,
          email: userData.email || "",
          fullName: medData.fullName || userData.fullName || "Nom non renseigné",
          age: medData.age || "",
          chronicDiseases: medData.chronicDiseases || "",
          currentTreatments: medData.currentTreatments || "",
          lastPeriod: medData.lastPeriod || "",
          allergies: medData.allergies || "",
          childrenCount: medData.childrenCount || "",
          contraceptionMethod: medData.contraceptionMethod || "",
          joinedAt: userData.createdAt || new Date().toISOString(),
          steriletDate: sterData.insertionDate || null,
          lastAppointment: lastAppt,
        });
      }
      setPatients(patientList);
      setLoading(false);
    }, (error) => {
      console.error("Firestore error:", error);
      setLoading(false);
    });
    return () => unsubscribe();
  }, [midwifeId]);

  // جلب المواعيد
  useEffect(() => {
    if (!midwifeId) return;
    const appointmentsRef = collection(db, "appointments");
    const q = query(appointmentsRef, orderBy("rawDate", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const apptList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      apptList.sort((a, b) => (b.rawDate || b.createdAt)?.localeCompare?.(a.rawDate || a.createdAt) || 0);
      setAppointments(apptList);
    }, (error) => {
      console.warn("Erreur chargement appointments:", error);
      setAppointments([]);
    });
    return () => unsubscribe();
  }, [midwifeId]);

  // تحميل المحادثات
  useEffect(() => {
    if (!midwifeId || patients.length === 0) return;
    const unsubscribes = [];
    patients.forEach(patient => {
      const q = query(
        collection(db, "chat_messages"),
        where("senderId", "in", [midwifeId, patient.uid]),
        where("receiverId", "in", [midwifeId, patient.uid])
      );
      const unsub = onSnapshot(q, (snapshot) => {
        const msgs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        msgs.sort((a, b) => (a.timestamp?.toDate?.() || 0) - (b.timestamp?.toDate?.() || 0));
        setChats(prev => ({ ...prev, [patient.uid]: msgs }));
      });
      unsubscribes.push(unsub);
    });
    return () => unsubscribes.forEach(unsub => unsub());
  }, [midwifeId, patients]);

  useEffect(() => {
    if (!document.getElementById("md-css")) {
      const s = document.createElement("style");
      s.id = "md-css";
      s.textContent = CSS;
      document.head.appendChild(s);
    }
  }, []);

  useEffect(() => {
    messagesEnd.current?.scrollIntoView({ behavior: "smooth" });
  }, [chats, selected, detailTab]);

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(null), 3000);
  };

  const filtered = patients.filter(p =>
    p.fullName.toLowerCase().includes(search.toLowerCase()) ||
    p.email.toLowerCase().includes(search.toLowerCase())
  );

  const handleSend = async (e) => {
    e.preventDefault();
    if (!newMsg.trim() || !selected || !midwifeId) return;
    const now = new Date();
    const time = `${now.getHours()}:${String(now.getMinutes()).padStart(2, "0")}`;
    try {
      await addDoc(collection(db, "chat_messages"), {
        senderId: midwifeId,
        receiverId: selected.uid,
        text: newMsg,
        timestamp: serverTimestamp(),
        time: time,
        read: false,
        role: "midwife"
      });
      setNewMsg("");
      showToast("Message envoyé");
    } catch (err) {
      console.error(err);
      showToast("Erreur d'envoi");
    }
  };

  const handleInboxSend = async (e) => {
    e.preventDefault();
    if (!inboxMsg.trim() || !inboxSelected || !midwifeId) return;
    const now = new Date();
    const time = `${now.getHours()}:${String(now.getMinutes()).padStart(2, "0")}`;
    try {
      await addDoc(collection(db, "chat_messages"), {
        senderId: midwifeId,
        receiverId: inboxSelected.uid,
        text: inboxMsg,
        timestamp: serverTimestamp(),
        time: time,
        read: false,
        role: "midwife"
      });
      setInboxMsg("");
      showToast("Message envoyé");
    } catch (err) {
      console.error(err);
      showToast("Erreur d'envoi");
    }
  };

  const today = new Date().toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" });
  const totalUnread = Object.values(chats).flat().filter(m => m.role === "patient" && !m.read).length;
  const steriletPatients = patients.filter(p => p.steriletDate);

  const navItems = [
    { id: "overview", label: "Vue d'ensemble", icon: "ti-layout-dashboard" },
    { id: "patients", label: "Patientes", icon: "ti-users", badge: patients.length },
    { id: "messages", label: "Messages", icon: "ti-message-2-heart", badge: totalUnread },
    { id: "agenda", label: "Agenda", icon: "ti-calendar-event" },
    { id: "rappels", label: "Rappels", icon: "ti-bell" },
  ];
  const tabTitles = {
    overview: "Vue d'ensemble",
    patients: "Gestion des patientes",
    messages: "Boîte de réception",
    agenda: "Agenda & rendez-vous",
    rappels: "Rappels personnalisés",
  };

  if (loading) {
    return (
      <div className="md-root">
        <div className="md-main" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <div style={{ textAlign: "center", color: "var(--plum)" }}>
            <i className="ti ti-loader" style={{ fontSize: 48, animation: "spin 1s linear infinite" }} />
            <p>Chargement des patientes...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!loading && patients.length === 0) {
    return (
      <div className="md-root">
        <div className="md-main">
          <div className="md-topbar"><div className="md-topbar-title">Tableau de bord</div><div className="md-topbar-right"><div className="md-topbar-date">{today}</div></div></div>
          <div className="md-content" style={{ textAlign: "center", paddingTop: 100 }}>
            <i className="ti ti-database-off" style={{ fontSize: 64, color: "var(--muted)", marginBottom: 20 }} />
            <h2>Aucune patiente trouvée</h2>
            <p>Assurez-vous qu'il existe des utilisateurs avec le rôle "patient" dans Firestore.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="md-root">
      <button className="md-mobile-menu-btn" onClick={() => setSidebarOpen(true)} aria-label="Ouvrir le menu">
        <i className="ti ti-menu-2" />
      </button>

      <div className={`md-sidebar-overlay${sidebarOpen ? " mobile-open" : ""}`} onClick={closeSidebar} />

      <aside className={`md-sidebar${sidebarOpen ? " mobile-open" : ""}`}>
        <div className="md-brand">
          <div className="md-brand-badge"><i className="ti ti-shield-heart" /> Espace sage-femme</div>
          <div className="md-brand-name"> <em>RosyHealth</em> </div>
          <div className="md-brand-sub">Tableau de bord</div>
        </div>
        <div className="md-sidebar-sep" />
        <nav className="md-nav">
          <div className="md-nav-section">Navigation</div>
          {navItems.map(item => (
            <button key={item.id} className={`md-nav-item${tab === item.id ? " active" : ""}`} onClick={() => handleNavClick(item.id)}>
              <i className={`ti ${item.icon}`} />
              {item.label}
              {item.badge && <span className="md-nav-badge">{item.badge}</span>}
            </button>
          ))}
        </nav>
        <div className="md-sidebar-footer">
          <div className="md-midwife-card">
            <div className="md-midwife-avatar"><i className="ti ti-stethoscope" /></div>
            <div><div className="md-midwife-name">Chams & Ikram</div><div className="md-midwife-role">Sages-femmes</div></div>
          </div>
          <button className="md-logout" onClick={onLogout}><i className="ti ti-logout" /> Déconnexion</button>
        </div>
      </aside>

      <div className="md-main">
        <div className="md-topbar">
          <div className="md-topbar-title">{tabTitles[tab]}</div>
          <div className="md-topbar-right">
            <div className="md-topbar-date"><i className="ti ti-calendar-event" />{today}</div>
            <div style={{ width: 36, height: 36, borderRadius: "50%", background: "var(--rose-light)", display: "flex", alignItems: "center", justifyContent: "center", border: "2px solid var(--rose)" }}>
              <i className="ti ti-stethoscope" style={{ color: "var(--rose-dark)", fontSize: 17 }} />
            </div>
          </div>
        </div>

        <div className="md-content md-animate" key={tab}>
          {tab === "overview" && (
            <>
              <div style={{ background: "linear-gradient(135deg,var(--plum),#5a003f)", borderRadius: "var(--radius)", padding: "40px 48px", position: "relative", overflow: "hidden", marginBottom: 24, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ position: "absolute", width: 300, height: 300, borderRadius: "50%", background: "rgba(196,137,154,0.1)", top: -100, right: -80 }} />
                <div style={{ position: "relative", zIndex: 2 }}>
                  <div style={{ fontSize: 11, letterSpacing: "0.25em", textTransform: "uppercase", color: "rgba(237,217,223,0.55)", marginBottom: 10 }}>Bonjour</div>
                  <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, fontWeight: 300, color: "white", lineHeight: 1.1, marginBottom: 10 }}>Bienvenue, <em style={{ fontStyle: "italic", color: "var(--rose-light)" }}>SF. Ikram & Chams El Assil</em></h1>
                  <p style={{ fontSize: 14, color: "rgba(255,255,255,0.55)", fontWeight: 300, maxWidth: 380, lineHeight: 1.7 }}>Vous avez <strong style={{ color: "var(--rose-light)" }}>{patients.length} patientes</strong> enregistrées dans votre espace. Consultez les dernières activités ci-dessous.</p>
                </div>
                <div style={{ position: "relative", zIndex: 2 }}>
                  <div style={{ width: 100, height: 100, borderRadius: "50%", background: "rgba(237,217,223,0.12)", border: "1px solid rgba(237,217,223,0.2)", display: "flex", alignItems: "center", justifyContent: "center" }}><i className="ti ti-heart-handshake" style={{ fontSize: 42, color: "var(--rose-light)" }} /></div>
                </div>
              </div>
              <div className="md-stats-row">
                {[
                  { ico: "ti-users", cls: "rose", n: patients.length, l: "Patientes totales" },
                  { ico: "ti-messages", cls: "gold", n: Object.values(chats).flat().length, l: "Messages échangés" },
                  { ico: "ti-refresh-dot", cls: "plum", n: steriletPatients.length, l: "Suivis stérilet" },
                  { ico: "ti-calendar-check", cls: "sage", n: appointments.length, l: "Rendez-vous" },
                ].map((s, i) => (
                  <div key={i} className="md-stat-card"><div className={`md-stat-ico ${s.cls}`}><i className={`ti ${s.ico}`} /></div><div><div className="md-stat-n">{s.n}</div><div className="md-stat-l">{s.l}</div></div></div>
                ))}
              </div>
              <div className="md-quick-grid">
                <div className="md-quick-card">
                  <div className="md-quick-card-title">Dernières patientes inscrites</div>
                  <div className="md-quick-card-list">
                    {[...patients].sort((a, b) => new Date(b.joinedAt) - new Date(a.joinedAt)).slice(0, 5).map(p => (
                      <div key={p.uid} className="md-quick-row"><div style={{ display: "flex", alignItems: "center", gap: 10 }}><div className="md-quick-row-dot" style={{ background: getColor(p.fullName) }} /><span className="md-quick-row-name">{p.fullName}</span></div><span className="md-quick-row-val">{formatDate(p.joinedAt).replace(/\s\d{4}/, "")}</span></div>
                    ))}
                  </div>
                </div>
                <div className="md-quick-card">
                  <div className="md-quick-card-title">Prochains rappels stérilet</div>
                  <div className="md-quick-card-list">
                    {steriletPatients.length === 0 && <div style={{ color: "var(--muted)", fontSize: 13, fontWeight: 300 }}>Aucun rappel programmé</div>}
                    {steriletPatients.map(p => {
                      const d = new Date(p.steriletDate); d.setMonth(d.getMonth() + 3);
                      return (<div key={p.uid} className="md-quick-row"><div style={{ display: "flex", alignItems: "center", gap: 10 }}><i className="ti ti-calendar-event" style={{ fontSize: 14, color: "var(--rose)" }} /><span className="md-quick-row-name">{p.fullName}</span></div><span className="md-quick-row-val">{d.toLocaleDateString("fr-FR", { day: "numeric", month: "short" })}</span></div>);
                    })}
                  </div>
                </div>
              </div>
            </>
          )}

          {tab === "patients" && (
            <>
              <div className="md-sh">Liste des <em>patientes</em></div>
              <div className="md-ssub">Cliquez sur une patiente pour voir son dossier complet et échanger des messages.</div>
              <div className="md-patients-layout">
                <div className="md-plist-wrap">
                  <div className="md-plist-header"><div className="md-plist-search"><i className="ti ti-search" /><input placeholder="Rechercher une patiente…" value={search} onChange={e => setSearch(e.target.value)} /></div><div className="md-plist-count">{filtered.length} patiente{filtered.length !== 1 ? "s" : ""}</div></div>
                  <div className="md-plist">
                    {filtered.map(p => (
                      <div key={p.uid} className={`md-pitem${selected?.uid === p.uid ? " selected" : ""}`} onClick={() => { setSelected(p); setDetailTab("info"); setSidebarOpen(false); }}>
                        <div className="md-pitem-av" style={{ background: getColor(p.fullName) }}>{getInitials(p.fullName)}</div>
                        <div style={{ flex: 1, minWidth: 0 }}><div className="md-pitem-name">{p.fullName}</div><div className="md-pitem-info">{p.age} ans · {p.contraceptionMethod}</div></div>
                        <div className={`md-pitem-badge ${p.steriletDate ? "active" : "pending"}`}>{p.steriletDate ? "Stérilet" : "Suivi"}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="md-pdetail">
                  {!selected ? (
                    <div className="md-pdetail-empty"><i className="ti ti-user-search" /><p>Sélectionnez une patiente pour voir ses détails</p></div>
                  ) : (
                    <>
                      <div className="md-pdetail-header">
                        <div className="md-pdetail-hrow"><div className="md-pdetail-av" style={{ background: getColor(selected.fullName) }}>{getInitials(selected.fullName)}</div><div><div className="md-pdetail-name">{selected.fullName}</div><div className="md-pdetail-email">{selected.email}</div></div></div>
                        <div className="md-pdetail-chips"><span className="md-chip"><i className="ti ti-cake" />{selected.age} ans</span><span className="md-chip"><i className="ti ti-baby-carriage" />{selected.childrenCount} enfant{selected.childrenCount !== "1" ? "s" : ""}</span><span className="md-chip"><i className="ti ti-pill" />{selected.contraceptionMethod}</span>{selected.steriletDate && <span className="md-chip"><i className="ti ti-refresh-dot" />Stérilet</span>}</div>
                      </div>
                      <div className="md-detail-tabs">
                        {[{ id: "info", label: "Dossier médical", icon: "ti-clipboard-heart" },{ id: "chat", label: "Messages", icon: "ti-message-2-heart" }].map(t => (
                          <button key={t.id} className={`md-dtab${detailTab === t.id ? " active" : ""}`} onClick={() => setDetailTab(t.id)}><i className={`ti ${t.icon}`} />{t.label}{t.id === "chat" && (chats[selected.uid] || []).length > 0 && (<span style={{ marginLeft: 4, background: "var(--rose)", color: "white", fontSize: 10, fontWeight: 600, borderRadius: 10, padding: "1px 7px" }}>{(chats[selected.uid] || []).length}</span>)}</button>
                        ))}
                      </div>
                      <div className="md-detail-body">
                        {detailTab === "info" && (
                          <div className="md-animate">
                            {selected.allergies && selected.allergies.toLowerCase() !== "aucune" && (<div className="md-detail-alert"><i className="ti ti-alert-circle" /><div className="md-detail-alert-text"><strong style={{ color: "var(--gold)", display: "block", marginBottom: 3 }}>Allergie(s) signalée(s)</strong>{selected.allergies}</div></div>)}
                            <div className="md-info-grid">
                              {[
                                { label: "Nom complet", val: selected.fullName, full: false },
                                { label: "Âge", val: `${selected.age} ans`, full: false },
                                { label: "Maladies chroniques", val: selected.chronicDiseases, full: false },
                                { label: "Traitements actuels", val: selected.currentTreatments, full: false },
                                { label: "Dernières règles", val: formatDate(selected.lastPeriod), full: false },
                                { label: "Nombre d'enfants", val: selected.childrenCount, full: false },
                                { label: "Contraception actuelle", val: selected.contraceptionMethod, full: true },
                                { label: "Allergies", val: selected.allergies || "Aucune", full: true },
                                selected.steriletDate && { label: "Date de pose stérilet", val: formatDate(selected.steriletDate), full: false },
                                selected.steriletDate && { label: "Prochain contrôle", val: (() => { const d = new Date(selected.steriletDate); d.setMonth(d.getMonth() + 3); return formatDate(d.toISOString().split("T")[0]); })(), full: false },
                              ].filter(Boolean).map((f, i) => (
                                <div key={i} className={`md-info-field${f.full ? " full" : ""}`}><div className="md-info-field-label">{f.label}</div><div className="md-info-field-val">{f.val}</div></div>
                              ))}
                            </div>
                          </div>
                        )}
                        {detailTab === "chat" && (
                          <div className="md-chat-wrap md-animate">
                            <div className="md-messages">
                              {(chats[selected.uid] || []).length === 0 ? (<div className="md-chat-empty"><i className="ti ti-message-off" /><p>Aucun message avec cette patiente</p></div>) : (
                                (chats[selected.uid] || []).map(msg => (
                                  <div key={msg.id} className={`md-msg ${msg.role === "midwife" ? "mine" : "theirs"}`}><div className="md-msg-bubble">{msg.text}</div><div className="md-msg-time">{msg.role === "midwife" ? "Vous" : selected.fullName.split(" ")[0]} · {msg.time}</div></div>
                                ))
                              )}
                              <div ref={messagesEnd} />
                            </div>
                            <form className="md-chat-input-bar" onSubmit={handleSend}><input className="md-chat-inp" value={newMsg} onChange={e => setNewMsg(e.target.value)} placeholder={`Répondre à ${selected.fullName.split(" ")[0]}…`} /><button type="submit" className="md-send-btn"><i className="ti ti-send-2" /></button></form>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          )}

          {tab === "messages" && (
            <>
              <div className="md-sh">Boîte de <em>réception</em></div>
              <div className="md-ssub">Toutes les conversations avec vos patientes en un seul endroit.</div>
              <div className="md-inbox-layout">
                <div className="md-inbox-list">
                  <div className="md-inbox-list-header"><div className="md-inbox-list-title">Conversations</div><div className="md-inbox-list-sub">{patients.length} patientes</div></div>
                  <div className="md-inbox-list-body">
                    {patients.map(p => {
                      const msgs = chats[p.uid] || [];
                      const last = msgs[msgs.length - 1];
                      const unread = msgs.filter(m => m.role === "patient" && !m.read).length;
                      return (
                        <div key={p.uid} className={`md-inbox-row${inboxSelected?.uid === p.uid ? " active" : ""}`} onClick={() => { setInboxSelected(p); setSidebarOpen(false); }}>
                          <div className="md-inbox-av" style={{ background: getColor(p.fullName) }}>{getInitials(p.fullName)}</div>
                          <div className="md-inbox-info"><div className="md-inbox-name">{p.fullName}</div><div className="md-inbox-preview">{last ? (last.role === "midwife" ? "Vous : " : "") + last.text : "Aucun message"}</div></div>
                          <div className="md-inbox-meta"><div className="md-inbox-time">{last ? last.time : ""}</div>{unread > 0 && <div className="md-inbox-unread">{unread}</div>}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="md-inbox-panel">
                  {!inboxSelected ? (
                    <div className="md-inbox-empty"><i className="ti ti-message-2-heart" /><p>Sélectionnez une conversation</p></div>
                  ) : (
                    <>
                      <div className="md-inbox-panel-header"><div className="md-inbox-panel-av" style={{ background: getColor(inboxSelected.fullName) }}>{getInitials(inboxSelected.fullName)}</div><div><div className="md-inbox-panel-name">{inboxSelected.fullName}</div><div className="md-inbox-panel-status"><div className="md-online-dot" /> En ligne · {inboxSelected.age} ans · {inboxSelected.contraceptionMethod}</div></div></div>
                      <div className="md-inbox-messages">
                        {(chats[inboxSelected.uid] || []).length === 0 ? (
                          <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, color: "var(--muted)" }}><i className="ti ti-message-off" style={{ fontSize: 40, opacity: 0.2 }} /><p>Aucun message avec cette patiente</p></div>
                        ) : (
                          (chats[inboxSelected.uid] || []).map(msg => (
                            <div key={msg.id} className={`md-msg ${msg.role === "midwife" ? "mine" : "theirs"}`}><div className="md-msg-bubble">{msg.text}</div><div className="md-msg-time">{msg.role === "midwife" ? "Vous" : inboxSelected.fullName.split(" ")[0]} · {msg.time}</div></div>
                          ))
                        )}
                        <div ref={messagesEnd} />
                      </div>
                      <form style={{ borderTop: "1px solid var(--border)", padding: "14px 24px", display: "flex", gap: 10, alignItems: "center", background: "white" }} onSubmit={handleInboxSend}><input className="md-chat-inp" value={inboxMsg} onChange={e => setInboxMsg(e.target.value)} placeholder={`Répondre à ${inboxSelected.fullName.split(" ")[0]}…`} /><button type="submit" className="md-send-btn"><i className="ti ti-send-2" /></button></form>
                    </>
                  )}
                </div>
              </div>
            </>
          )}

          {tab === "agenda" && (
            <>
              <div className="md-sh">Agenda & <em>rendez-vous</em></div>
              <div className="md-ssub">Gérez vos consultations et planifiez les prochains suivis.</div>
              {appointments.length === 0 ? (
                <div style={{ background: "white", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: "48px", textAlign: "center", color: "var(--muted)" }}>
                  <i className="ti ti-calendar-off" style={{ fontSize: 56, display: "block", marginBottom: 16, opacity: 0.25 }} />
                  <div style={{ fontSize: 16, fontFamily: "'Cormorant Garamond',serif", color: "var(--plum)", marginBottom: 8 }}>Aucun rendez-vous planifié</div>
                  <div style={{ fontSize: 13, fontWeight: 300 }}>Les rendez-vous pris par les patientes apparaîtront ici.</div>
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                  {appointments.map(appt => {
                    const patient = patients.find(p => p.uid === appt.patientId);
                    const displayName = appt.patientName || patient?.fullName || "Patiente inconnue";
                    return (
                      <div
                        key={appt.id}
                        style={{
                          background: "white",
                          borderRadius: "var(--radius)",
                          border: "1px solid var(--border)",
                          padding: "24px 28px",
                          display: "flex",
                          flexWrap: "wrap",
                          justifyContent: "space-between",
                          alignItems: "center",
                          cursor: "pointer",
                          transition: "transform 0.2s, box-shadow 0.2s"
                        }}
                        onClick={() => {
                          const found = patients.find(p => p.uid === appt.patientId);
                          if (found) {
                            setSelected(found);
                            setTab("patients");
                            setDetailTab("info");
                            setSidebarOpen(false);
                          }
                        }}
                        onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 8px 28px rgba(139,90,106,0.08)"; }}
                        onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                          <div style={{ width: 50, height: 50, borderRadius: "12px", background: "var(--rose-light)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <i className="ti ti-calendar-event" style={{ fontSize: 26, color: "var(--plum)" }} />
                          </div>
                          <div>
                            <div style={{ fontWeight: 600, fontSize: "16px", color: "var(--text-dark)" }}>{displayName}</div>
                            <div style={{ fontSize: "13px", color: "var(--muted)" }}>{appt.date} à {appt.time}</div>
                            <div style={{ fontSize: "13px", color: "var(--rose-dark)", marginTop: 4 }}>
                              <i className="ti ti-info-circle" style={{ fontSize: 12, marginRight: 4 }} />
                              {appt.reason || "Motif non précisé"}
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                          <span style={{
                            background: appt.status === "confirmed" ? "#e8f7ee" : "#FFF8EE",
                            color: appt.status === "confirmed" ? "#2e7d52" : "#7a5a20",
                            padding: "4px 12px", borderRadius: "40px", fontSize: "12px", fontWeight: 500
                          }}>
                            {appt.status === "confirmed" ? "Confirmé" : "En attente"}
                          </span>
                          <i className="ti ti-chevron-right" style={{ color: "var(--rose)", fontSize: 18 }} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          )}

          {tab === "rappels" && (
            <>
              <div className="md-sh">Rappels <em>stérilet</em></div>
              <div className="md-ssub">Liste des patientes nécessitant un contrôle prochain de leur stérilet.</div>
              {steriletPatients.length === 0 ? (
                <div style={{ background: "white", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: "48px", textAlign: "center", color: "var(--muted)" }}>
                  <i className="ti ti-bell-off" style={{ fontSize: 56, display: "block", marginBottom: 16, opacity: 0.25 }} />
                  <div style={{ fontSize: 16, fontFamily: "'Cormorant Garamond',serif", color: "var(--plum)", marginBottom: 8 }}>Aucun rappel de stérilet</div>
                  <div style={{ fontSize: 13, fontWeight: 300 }}>Aucune patiente n'a enregistré de date de pose de stérilet pour le moment.</div>
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                  {steriletPatients.map(p => {
                    const insertionDate = new Date(p.steriletDate);
                    const nextCheck = new Date(insertionDate);
                    nextCheck.setMonth(nextCheck.getMonth() + 3);
                    const todayDate = new Date();
                    todayDate.setHours(0, 0, 0, 0);
                    const daysLeft = Math.ceil((nextCheck - todayDate) / (1000 * 60 * 60 * 24));
                    let statusText = "";
                    let statusColor = "";
                    if (daysLeft < 0) {
                      statusText = "Dépassé";
                      statusColor = "#C62828";
                    } else if (daysLeft === 0) {
                      statusText = "Aujourd'hui !";
                      statusColor = "#E65100";
                    } else if (daysLeft <= 7) {
                      statusText = `Dans ${daysLeft} jour${daysLeft > 1 ? "s" : ""}`;
                      statusColor = "#E65100";
                    } else {
                      statusText = `Dans ${daysLeft} jours`;
                      statusColor = "#2E7D32";
                    }
                    return (
                      <div
                        key={p.uid}
                        style={{
                          background: "white",
                          borderRadius: "var(--radius)",
                          border: "1px solid var(--border)",
                          padding: "24px 28px",
                          display: "flex",
                          flexWrap: "wrap",
                          justifyContent: "space-between",
                          alignItems: "center",
                          cursor: "pointer",
                          transition: "transform 0.2s, box-shadow 0.2s"
                        }}
                        onClick={() => {
                          setSelected(p);
                          setTab("patients");
                          setDetailTab("info");
                          setSidebarOpen(false);
                        }}
                        onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 8px 28px rgba(139,90,106,0.08)"; }}
                        onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                          <div style={{ width: 50, height: 50, borderRadius: "12px", background: "var(--rose-light)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <i className="ti ti-refresh-dot" style={{ fontSize: 26, color: "var(--plum)" }} />
                          </div>
                          <div>
                            <div style={{ fontWeight: 600, fontSize: "16px", color: "var(--text-dark)" }}>{p.fullName}</div>
                            <div style={{ fontSize: "13px", color: "var(--muted)" }}>
                              Pose le : {formatDate(p.steriletDate)}
                            </div>
                            <div style={{ fontSize: "13px", color: "var(--rose-dark)", marginTop: 4 }}>
                              <i className="ti ti-calendar-event" style={{ fontSize: 12, marginRight: 4 }} />
                              Contrôle recommandé : {nextCheck.toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                          <span style={{
                            background: daysLeft < 0 ? "#FFEBEE" : daysLeft <= 7 ? "#FFF8EE" : "#E8F5E9",
                            color: statusColor,
                            padding: "4px 12px", borderRadius: "40px", fontSize: "12px", fontWeight: 500
                          }}>
                            {statusText}
                          </span>
                          <i className="ti ti-chevron-right" style={{ color: "var(--rose)", fontSize: 18 }} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {toast && <div className="md-toast"><i className="ti ti-circle-check-filled" />{toast}</div>}
    </div>
  );
}